import Api from 'libs/api';

class AnalyticsApi extends Api {
  constructor() {
    super('admin/analytics/');
  }
}

export default AnalyticsApi;
